import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'cmps-help',
    templateUrl: './help.component.html',
})
export class HelpComponent implements OnInit {
    /** @private */ _url: SafeResourceUrl;

    constructor(private readonly _domSanitizer: DomSanitizer) {}

    ngOnInit(): void {
        // TODO this is temporary
        const virtualPath = document
            .getElementsByTagName('base')[0]
            .getAttribute('href')
            .replace(/\/ui\//, '/');
        const url = `${window.location.origin}${virtualPath}help-nav-item/help/`;

        if (url) {
            this._url = this._domSanitizer.bypassSecurityTrustResourceUrl(url);
        }
    }
}
